"use strict";

import React from "react";

import { PostHogProvider } from "./providers/posthogProvider";
import AfterAuthModals from "./shared/react/components/AfterAuthModals";
import ReactRouter from "./shared/react/components/ReactRouter";
import { AuthenticationProvider } from "./shared/react/contexts/authentication";
import { ModalProvider } from "./shared/react/contexts/modal";
import { StripeStatusProvider } from "./shared/react/contexts/stripeStatus";

const CitifydApp = () => (
  <PostHogProvider>
    <AuthenticationProvider>
      <StripeStatusProvider>
        <ModalProvider>
          <AfterAuthModals>
            <ReactRouter />
          </AfterAuthModals>
        </ModalProvider>
      </StripeStatusProvider>
    </AuthenticationProvider>
  </PostHogProvider>
);

export default CitifydApp;
